$(() => {
  $('.currency-drop-down__trigger').on('click', () => {
    const isOpening = !$('.currency-drop-down').hasClass('currency-drop-down--is-open');
    
    $('.currency-drop-down__menu').toggle()
    $('.currency-drop-down').toggleClass('currency-drop-down--is-open')
    
    // If opening currency dropdown, close filters and sort
    if (isOpening) {
      // Close all filters
      $('details.js-filter').each(function() {
        $(this).prop('open', false);
        $(this).addClass('opacity-0');
      });
      
      // Close sort dropdown
      const sortSelect = document.querySelector('.select-unique');
      if (sortSelect && !sortSelect.classList.contains('opacity-0')) {
        sortSelect.classList.add('opacity-0');
      }
    }
  })

  $('.currency-drop-down__menu-item').on('click', (e) => {
    $('.currency-drop-down select[name="currency"]').val(e.target.innerHTML)
    $('.currency-drop-down').submit()
  })
})